import { CSSObjectWithLabel, Theme } from 'react-select'

// react-select's own colours as the design tokens (styles/index.css): the
// defaults under the site's styles - the control, the menu, the placeholder,
// the focus ring - follow the light and the dark theme. The placeholder is
// the secondary ink: react-select's grey read at 3.9:1.
export const selectTheme = (theme: Theme): Theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: 'rgb(var(--brand))',
    primary75: 'rgb(var(--brand) / 0.75)',
    primary50: 'rgb(var(--brand) / 0.3)',
    primary25: 'rgb(var(--brand) / 0.08)',
    danger: 'rgb(var(--danger))',
    dangerLight: 'rgb(var(--danger-soft))',
    neutral0: 'rgb(var(--surface))',
    neutral5: 'rgb(var(--page))',
    neutral10: 'rgb(var(--muted-soft))',
    neutral20: 'rgb(var(--ink) / 0.18)',
    neutral30: 'rgb(var(--ink) / 0.3)',
    neutral40: 'rgb(var(--ink-2))',
    neutral50: 'rgb(var(--ink-2))',
    neutral60: 'rgb(var(--ink-2))',
    neutral70: 'rgb(var(--ink))',
    neutral80: 'rgb(var(--ink))',
    neutral90: 'rgb(var(--ink))',
  },
})

// react-select draws its arrow and cross in neutral20, the colour of a field's
// frame (18% ink, 1.4:1): the secondary ink makes them readable (3:1 and more)
export const selectIndicatorStyles = {
  dropdownIndicator: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'rgb(var(--ink-2))',
    '&:hover': { color: 'rgb(var(--ink))' },
  }),
  clearIndicator: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'rgb(var(--ink-2))',
    '&:hover': { color: 'rgb(var(--ink))' },
  }),
}
